export default __webpack_public_path__ + "static/media/portfolio4.ca22bb89.png";